import React from 'react';
import {useParams} from "react-router-dom";

export const Materials = () => {
    const {id} = useParams();
    return (
        <div>материалы к событию {id}</div>
    );
}
